/**
 * Created by pmnia on 12/03/15.
 */
(function () {
    'use strict';
    angular
        .module('blocks.storage')
        .factory('reminderServices', reminderServices);

    /*@ngInject*/
    function reminderServices($localStorage){
        initStorage(); //run the init function
        return  {
            add: add,
            get: get,
            clear: clear
        };

        function initStorage(){
            if (!$localStorage.obtRememberMe) {
                $localStorage.obtRememberMe = {};
            }
        }

        function add(data) {
            $localStorage.obtRememberMe = data;
        }

        function get(){
            return $localStorage.obtRememberMe;
        }

        function clear(){
            $localStorage.obtRememberMe = {};
        }
    }
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/blocks/storage/reminder.service.js
 ** module id = 96
 ** module chunks = 0
 **/